/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingDetailsRequestModelProductCategory {
    getFixupPrototypeFunction() { return BillingDetailsRequestModelProductCategory.fixupPrototype; }

    static newInstance(model: Partial<BillingDetailsRequestModelProductCategory>): BillingDetailsRequestModelProductCategory {
        let obj = Object.assign(new BillingDetailsRequestModelProductCategory(), model);
        BillingDetailsRequestModelProductCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingDetailsRequestModelProductCategory>): BillingDetailsRequestModelProductCategory {
        if (!model) return null;
        return BillingDetailsRequestModelProductCategory.newInstance(<BillingDetailsRequestModelProductCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingDetailsRequestModelProductCategory) {
        if (!obj) return;

        models.BillingDetailsRequestModelProductCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingDetailsRequestModelProductCategory): boolean {
        Object.setPrototypeOf(obj, BillingDetailsRequestModelProductCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Date Filter to select
     */
    date_filter: models.DashboardDateFilter;

}
